import React, { useState, useRef, useEffect } from "react";
import { IoSendSharp } from "react-icons/io5";
import { motion, AnimatePresence } from "framer-motion";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { handleAPIRequest } from "../../api/api";
import { FaThumbsUp, FaThumbsDown, FaRedo, FaCopy } from "react-icons/fa";
import { FaMoon } from "react-icons/fa";
import { useSelector } from "react-redux";


const ChatBot = ({ companyName }) => {
  const token = useSelector((state) => state.auth.token); 
  const [messages, setMessages] = useState([]);
  const [messageInput, setMessageInput] = useState("");
  const [isTyping, setIsTyping] = useState(false);
  const messagesEndRef = useRef(null);
  const [showHello, setShowHello] = useState(true);

  const [showModal, setShowModal] = useState(true);
  const [secretKey, setSecretKey] = useState("");
  const [verificationMessage, setVerificationMessage] = useState("");

  const [isDarkMode, setIsDarkMode] = useState(false);

  const handleVerify = async () => {
    const formData = new FormData();
    formData.append("secretKey", secretKey);
    formData.append("companyName", companyName);
    const response = await handleAPIRequest("post", "initiate-chat/", formData, null, null);
    // console.log(response);
    // return;
    if (response.status === 200) {
      toast.success("Verified Successfully!");
      setSecretKey(response.data.secret_key);
      setShowModal(false);
    } else {
      setVerificationMessage("Verification not successful. Kindly enter the correct secret key.");
      setSecretKey("");
    }
  };

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    if (messages.length > 0 && messages[0].type === "sent") {
      setTimeout(() => setShowHello(false), 500);
    }
  }, [messages]);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault(); // Prevent adding space or a new line
      handleSendMessage(); // Call the function to send the message
    }
  };
  const handleSendMessage = async () => {
    if (!messageInput.trim() || isTyping) return;
  
    const userMessage = messageInput;
    setMessages((prevMessages) => [...prevMessages, { text: userMessage, type: "sent" }]);
    setMessageInput("");
    setIsTyping(true);
  
    try {
      const formData = new FormData();
      formData.append("query", userMessage);
      formData.append("companyName", companyName);
  
      const response = await handleAPIRequest("post", "chat-with/", formData, null, null);
  
      // Check if response is valid
      const botReply = response?.data?.recieve_msg || response?.data?.receive_msg;
      if (!botReply) {
        throw new Error("Empty response");
      }
  
      setMessages((prevMessages) => [
        ...prevMessages,
        { text: botReply, type: "received" },
      ]);
    } catch (error) {
      console.error("Chat error:", error);
  
      let errorMsg = "Cannot send message. Please try again later.";
  
      // You could customize error feedback more if needed:
      if (error.response?.status === 500) {
        errorMsg = "Server error (500). Please try again shortly.";
      } else if (error.message === "Empty response") {
        errorMsg = "No response from the server.";
      }
  
      setMessages((prevMessages) => [
        ...prevMessages,
        { text: errorMsg, type: "received" },
      ]);
  
      //toast.error(errorMsg); // optional: show toast as well
    } finally {
      setIsTyping(false);
    }
  };
  
  // const handleSendMessage = async () => {
  //   if (!messageInput.trim() || isTyping) return;

  //   const userMessage = messageInput;
  //   setMessages((prevMessages) => [...prevMessages, { text: userMessage, type: "sent" }]);
  //   setMessageInput("");
  //   setIsTyping(true);

  //   try {
  //     const formData = new FormData();
  //     formData.append("query", userMessage);
  //     formData.append("companyName", companyName);

  //     const response = await handleAPIRequest("post", "chat-with/", formData, null, null);
  //     setMessages((prevMessages) => [
  //       ...prevMessages,
  //       { text: response.data?.recieve_msg || response.data?.receive_msg, type: "received" },
  //     ]);
  //   } catch (error) {
  //     // setMessages((prevMessages) => [
  //     //   ...prevMessages,
  //     //   { text: "Error communicating with the server.", type: "received" },
  //     // ]);
  //     setMessages((prevMessages) => [
  //       ...prevMessages,
  //       { text: "Cannot reply at the moment, please try again later. Sorry for the inconvenience.", type: "received" },
  //     ]);
  //   } finally {
  //     setIsTyping(false);
  //   }
  // };

  return (
    <div className={`flex flex-col h-screen ${isDarkMode ? "bg-[#202124]" : "bg-white"} text-white relative`}>
      {/* Navbar */}
      <div className="flex justify-between items-center p-4 bg-gray-800">
        <div className="text-white font-bold text-xl">ChatBot</div>
        <div className="flex items-center space-x-4">
          <div className="w-8 h-8 bg-blue-500 rounded-full"></div> {/* Circle Logo */}
          <button
  onClick={() => setIsDarkMode(!isDarkMode)}
  className={`text-white p-2 rounded-full border-2 border-gray-600 hover:bg-gray-400 z-10  ${isDarkMode ? 'bg-yellow-400 shadow-lg' : 'bg-gray-700'}`}
>

   <FaMoon />
 
</button>


        </div>
      </div>

      {/* Modal for Secret Key Verification */}
      {showModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 p-4">
          <div className="bg-gray-800 p-4 sm:p-6 rounded-lg shadow-lg text-center w-full max-w-[90%] sm:max-w-[800px]">
            <h2 className="text-lg font-bold text-white mb-4">Enter Secret Key</h2>
            <input
              type="password"
              value={secretKey}
              onChange={(e) => setSecretKey(e.target.value)}
              className="w-full p-2 rounded-lg bg-gray-700 text-white text-center focus:outline-none"
              placeholder="Enter secret key"
            />
            {verificationMessage && <p className="text-red-500 mt-2">{verificationMessage}</p>}
            <button
              className="mt-4 px-6 py-2 bg-blue-500 hover:bg-blue-600 rounded-lg text-white font-bold"
              onClick={handleVerify}
            >
              Verify
            </button>
          </div>
        </div>
      )}

      {/* Hello Message */}
      <AnimatePresence>
        {showHello && (
          <motion.div
            initial={{ opacity: 1, y: 0 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -50 }}
            transition={{ duration: 1 }}
            className="absolute top-0 left-0 right-0 bottom-[80px] flex items-center justify-center p-4 sm:p-6"
          >
            <div className="text-2xl sm:text-4xl font-bold text-gray-400">Hello, {companyName} </div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Messages */}
      <div className="flex-grow overflow-y-auto p-6 space-y-6">
      {messages.map((msg, index) => (
  <motion.div
    key={index}
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.3 }}
    className={`flex ${msg.type === "sent" ? "justify-end" : "justify-center"}`}
  >
    {msg.type === "sent" ? (
      <div
        className={`relative px-6 py-3 rounded-2xl max-w-[60%] sm:max-w-[40%] shadow-lg break-words whitespace-pre-wrap ${
          isDarkMode ? "bg-gray-600 text-white" : "bg-white text-black border border-gray-300"
        }`}
        style={{ marginRight: "20%" }}
      >
        {msg.text}
        <div className="absolute bottom-0 right-0 w-2 h-2 transform rotate-45 translate-x-2 translate-y-2">
          {isDarkMode ? (
            <div className="bg-gray-600"></div>
          ) : (
            <div className="bg-white border border-gray-300"></div>
          )}
        </div>
      </div>
    ) : (
      <div
        className={`${
          isDarkMode
            ? "bg-gray-700 text-gray-100"
            : "bg-white text-black border border-gray-300 shadow-md"
        } px-6 py-3 rounded-2xl w-[850px] shadow-md`}

      >
        {/* Check if msg.text is defined and contains "Cannot reply at the moment" */}
        {/* {msg.text && msg.text.includes("Cannot reply at the moment") ? (
          <div className="bg-red-600 text-white px-6 py-3 rounded-2xl max-w-[80%] sm:max-w-[60%] shadow-lg break-words whitespace-pre-wrap">
            {msg.text}
          </div>
        ) : (
          <div dangerouslySetInnerHTML={{ __html: msg.text }} />
        )} */}
       {msg.text && msg.type === "received" && msg.text.toLowerCase().includes("cannot") ? (
  <div className="bg-red-600 text-white px-6 py-3 rounded-2xl ...">
    {msg.text}
  </div>
) : (
          <div dangerouslySetInnerHTML={{ __html: msg.text }} />
        )}
      </div>
    )}
  </motion.div>
))}

  {isTyping && (
    <motion.div
  initial={{ opacity: 0 }}
  animate={{ opacity: 1 }}
  transition={{ duration: 0.5, repeat: Infinity, repeatType: "reverse" }}
  className="flex justify-start"
  style={{ marginLeft: "20%" }} // Adjust margin to align with sent messages
>
  <div className="w-5 h-5 bg-gray-600 rounded-full animate-pulse"></div>
</motion.div>
  )}
  <div ref={messagesEndRef} />
</div>


      {/* Input Section */}
      <div className="w-full px-4 sm:px-8 pb-6 flex justify-center">
        <div className="w-full sm:w-[60%] flex items-center bg-transparent border border-gray-500 rounded-xl p-3 sm:p-4 shadow-lg">
          <textarea
            value={messageInput}
            onKeyDown={handleKeyDown}
            placeholder="Ask Chatbot..."
            className={`flex-1 bg-transparent text-lg ${isDarkMode ? 'text-white' : 'text-black'} placeholder-gray-400 focus:outline-none px-4 py-3 rounded-xl resize-none min-h-[50px] max-h-[150px] overflow-auto`}
            onChange={(e) => setMessageInput(e.target.value)}
          />
         <button
  className={`p-2 sm:p-3 rounded-full transition-all flex items-center justify-center ${isTyping ? "text-gray-500 cursor-not-allowed" : "text-blue-400 hover:text-blue-600"}`}
  onClick={handleSendMessage}
  disabled={isTyping}
>
  {isTyping ? (
    <div className="w-5 h-5 border-2 border-t-transparent border-gray-400 rounded-full animate-spin"></div>
  ) : (
    <IoSendSharp size={24} className="sm:size-30" />
  )}
</button>
        </div>
      </div>

      <ToastContainer />
    </div>
  );
};

export default ChatBot;
